module.exports = __webpack_public_path__ + "img/houdini.f025be70.png";